import { EnvironmentInjector, inject, Service, InjectionToken, runInInjectionContext } from '@angular/core'
import { defaultGetTokens, fetchJson, toQueryParams } from './utils/fetch-utils'
import { apiBaseUrl } from './utils/api-base-url'
import { LoggerService } from '../logging/logger.service'

export const API_HOST = new InjectionToken<string>('API_HOST')
export const API_PREFIX = new InjectionToken<string>('API_PREFIX')
export const GET_TOKENS = new InjectionToken<() => string>('GET_TOKENS')
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- lint-debt
export const HANDLE_AUTH_ERROR = new InjectionToken<(error: any) => void>('HANDLE_AUTH_ERROR')

@Service()
export class ApiService {
  private environmentInjector = inject(EnvironmentInjector)

  private apiHost = inject(API_HOST, { optional: true }) || ''
  private apiPrefix = inject(API_PREFIX, { optional: true }) || ''
  private readonly getTokens = inject(GET_TOKENS, { optional: true }) || defaultGetTokens

  readonly toQueryParams = toQueryParams

  createURL(path: string): URL {
    const url = apiBaseUrl(this.apiHost, this.apiPrefix, window.location.origin)

    if (path.startsWith('/')) {
      path = path.slice(1) // Remove leading slash from path
    }
    return new URL(`${url}/${path}`)
  }

  overrideHost(host: string): void {
    this.apiHost = host
  }
  overridePrefix(prefix: string): void {
    this.apiPrefix = prefix
  }

  fetchJson<T>(input: RequestInfo | URL, init?: RequestInit | undefined) {
    if (typeof input === 'string') {
      input = this.createURL(input)
    }
    return fetchJson<T>(input, init, true)
  }

  async protectedFetchJson<T>(input: RequestInfo | URL, init?: RequestInit | undefined, handleAuthError = true) {
    if (typeof input === 'string') {
      input = this.createURL(input)
    }
    try {
      return await fetchJson<T>(input, init, true, this.getTokens)
    } catch (error) {
      runInInjectionContext(this.environmentInjector, () => {
        const logger = inject(LoggerService).forContext('ApiService')
        const handleAuthErrorFn =
          inject(HANDLE_AUTH_ERROR, { optional: true }) ||
          (() => {
            logger.warn('auth error with no HANDLE_AUTH_ERROR handler provided')
          })
        if (handleAuthError) {
          handleAuthErrorFn(error)
        }
      })
      throw error
    }
  }
}
